import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, FileText, PlusCircle, User, LogOut, Menu, X, Shield, Bell } from 'lucide-react';
import { Button } from '../ui/Button';
interface CustomerLayoutProps {
  children: React.ReactNode;
}
export function CustomerLayout({
  children
}: CustomerLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigation = [{
    name: 'داشبورد',
    href: '/dashboard',
    icon: LayoutDashboard
  }, {
    name: 'بیمه‌های من',
    href: '/policies',
    icon: Shield
  }, {
    name: 'خرید بیمه جدید',
    href: '/insurance/select',
    icon: PlusCircle
  }, {
    name: 'پیگیری خسارت',
    href: '/claims',
    icon: FileText
  }, {
    name: 'پروفایل کاربری',
    href: '/profile',
    icon: User
  }];
  const isActive = (path: string) => location.pathname === path;
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-71">
      {/* Mobile Sidebar Overlay */}
      {isSidebarOpen && <div className="fixed inset-0 bg-black/50 z-40 lg:hidden" onClick={() => setIsSidebarOpen(false)} data-id="element-72" />}

      {/* Sidebar */}
      <aside className={`
        fixed lg:static inset-y-0 right-0 z-50 w-64 bg-white border-l transform transition-transform duration-200 ease-in-out
        ${isSidebarOpen ? 'translate-x-0' : 'translate-x-full lg:translate-x-0'}
      `} data-id="element-73">
        <div className="h-16 flex items-center justify-between px-6 border-b" data-id="element-74">
          <div className="flex items-center gap-2 font-bold text-xl text-primary" data-id="element-75">
            <Shield className="h-6 w-6" data-id="element-76" />
            <span data-id="element-77">بیمه آنلاین</span>
          </div>
          <button onClick={() => setIsSidebarOpen(false)} className="lg:hidden text-gray-500" data-id="element-78">
            <X className="h-6 w-6" data-id="element-79" />
          </button>
        </div>

        <nav className="p-4 space-y-1" data-id="element-80">
          {navigation.map(item => <Link key={item.href} to={item.href} className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors ${isActive(item.href) ? 'bg-primary/10 text-primary' : 'text-gray-600 hover:bg-gray-100 hover:text-gray-900'}`} data-id="element-81">
              <item.icon className="h-5 w-5" data-id="element-82" />
              {item.name}
            </Link>)}
        </nav>

        <div className="absolute bottom-0 w-full p-4 border-t" data-id="element-83">
          <Link to="/" data-id="element-84">
            <Button variant="ghost" className="w-full justify-start text-red-600 hover:text-red-700 hover:bg-red-50" data-id="element-85">
              <LogOut className="h-5 w-5 ml-2" data-id="element-86" />
              خروج از حساب
            </Button>
          </Link>
        </div>
      </aside>

      {/* Main Content */}
      <div className="flex-1 flex flex-col min-w-0" data-id="element-87">
        {/* Header */}
        <header className="h-16 bg-white border-b flex items-center justify-between px-4 lg:px-8" data-id="element-88">
          <button onClick={() => setIsSidebarOpen(true)} className="lg:hidden p-2 text-gray-600 hover:bg-gray-100 rounded-md" data-id="element-89">
            <Menu className="h-6 w-6" data-id="element-90" />
          </button>

          <div className="flex items-center gap-4 mr-auto" data-id="element-91">
            <button className="p-2 text-gray-500 hover:bg-gray-100 rounded-full relative" data-id="element-92">
              <Bell className="h-5 w-5" data-id="element-93" />
              <span className="absolute top-1.5 right-1.5 h-2 w-2 bg-red-500 rounded-full" data-id="element-94"></span>
            </button>
            <div className="flex items-center gap-3" data-id="element-95">
              <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center text-primary font-bold" data-id="element-96">
                ع
              </div>
              <span className="text-sm font-medium hidden sm:block" data-id="element-97">
                علی احمدی
              </span>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="flex-1 p-4 lg:p-8 overflow-auto" data-id="element-98">
          <div className="max-w-6xl mx-auto" data-id="element-99">{children}</div>
        </main>
      </div>
    </div>;
}